module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "personal-center-form__section"
  }, [(Number(_vm.userInfo.crmCustomerType) === 1) ? _c('div', [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("实名认证")]), _vm._v(" "), _c('div', {
    staticClass: "personal-center-form__main"
  }, [_c('el-row', {
    staticClass: "personal-center-form__form",
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "realAuthForm",
    attrs: {
      "label-width": '55%',
      "model": _vm.realAuthFormModel,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请上传身份证正反面"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('ul', {
    staticClass: "file-list__item-list1"
  }, [_vm._l((_vm.idCardFrontId), function(file) {
    return [_c('li', {
      staticClass: "file-list__item-preview2"
    }, [_c('img', {
      attrs: {
        "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + _vm.tokenId)
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.canDel),
        expression: "canDel"
      }],
      staticClass: "file-list__item-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteUploadedFile2(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })])])]
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.idCardFrontId.length < 1),
      expression: "idCardFrontId.length < 1"
    }],
    staticClass: "file-list__select-file2",
    staticStyle: {
      "width": "270px",
      "height": "200px"
    },
    attrs: {
      "id": "reder"
    }
  })], 2)]), _vm._v(" "), _c('el-form-item', [_vm._l((_vm.idCardBackId), function(file) {
    return [_c('li', {
      staticClass: "file-list__item-preview2",
      staticStyle: {
        "margin-top": "-222px",
        "margin-left": "155px"
      }
    }, [_c('img', {
      attrs: {
        "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + _vm.tokenId)
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.canDel),
        expression: "canDel"
      }],
      staticClass: "file-list__item-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteUploadedFile3(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })])])]
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.idCardBackId.length < 1),
      expression: "idCardBackId.length < 1"
    }],
    staticClass: "file-list__select-file2",
    staticStyle: {
      "width": "270px",
      "height": "200px",
      "margin-top": "-222px",
      "margin-left": "150px"
    },
    attrs: {
      "id": "reder2"
    }
  })], 2), _vm._v(" "), _c('el-form-item', {
    ref: "name",
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名",
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.realAuthFormModel.name),
      callback: function($$v) {
        _vm.$set(_vm.realAuthFormModel, "name", $$v)
      },
      expression: "realAuthFormModel.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    ref: "idno",
    attrs: {
      "label": "身份证号码",
      "prop": "idno"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入身份证号码",
      "disabled": _vm.isEditable,
      "maxlength": _vm.IDMaxLength
    },
    model: {
      value: (_vm.realAuthFormModel.idno),
      callback: function($$v) {
        _vm.$set(_vm.realAuthFormModel, "idno", $$v)
      },
      expression: "realAuthFormModel.idno"
    }
  })], 1), _vm._v(" "), (!_vm.isEditable) ? _c('div') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tips_info el-icon-information"
  }, [_vm._v("如有信息出错，请联系管理员修改")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.isAuth && _vm.auditState !== '-1' && _vm.auditState !== '1') ? _c('el-button', {
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("开始认证\n            ")]) : _vm._e(), _vm._v(" "), (_vm.auditState == '-1') ? _c('el-button', {
    staticClass: "personal-center-form__alreadyAuth",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving,
      "disabled": _vm.auditState === '-1'
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("已提交\n            ")]) : _vm._e(), _vm._v(" "), (_vm.auditState == '1') ? _c('el-button', {
    staticClass: "personal-center-form__alreadyAuth",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving,
      "disabled": _vm.auditState === '1'
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("已认证\n            ")]) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), (Number(_vm.userInfo.crmCustomerType) === 2) ? _c('div', [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("企业认证")]), _vm._v(" "), _c('div', {
    staticClass: "personal-center-form__main"
  }, [_c('el-row', {
    staticClass: "personal-center-form__form",
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "realAuthForm",
    attrs: {
      "label-width": '50%',
      "model": _vm.enterpriseInfoFormModel,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "customerName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入客户名称",
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.customerName),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "customerName", $$v)
      },
      expression: "enterpriseInfoFormModel.customerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照号",
      "prop": "enterpriseNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入营业执照号",
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "办公地址",
      "prop": "enterpriseOfficeAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入办公地址",
      "disabled": _vm.isEditable,
      "maxlength": 80,
      "resize": "none",
      "rows": 2
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseOfficeAddress),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseOfficeAddress", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseOfficeAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '法定代表人' : '代理人',
      "required": true,
      "prop": "enterpriseLegalUser"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人' : '请输入代理人',
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseLegalUser),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseLegalUser", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseLegalUser"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '法定代表人身份证号' : '代理人身份证号',
      "required": true,
      "prop": "enterpriseLegalIdNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人身份证号' : '请输入代理人身份证号',
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseLegalIdNo),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseLegalIdNo", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseLegalIdNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '法定代表人联系电话' : '代理人联系电话',
      "required": true,
      "prop": "enterpriseLegalUserPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人联系电话' : '请输入法定代表人联系电话',
      "disabled": _vm.isEditable,
      "maxlength": 11
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseLegalUserPhone),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseLegalUserPhone", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseLegalUserPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经办人",
      "required": true,
      "prop": "enterpriseAgentUser"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入经办人",
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseAgentUser),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseAgentUser", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseAgentUser"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.setAgent
    },
    slot: "append"
  }, [_vm._v("同法定代表人")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经办人身份证号",
      "required": true,
      "prop": "enterpriseAgentIdNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入经办人身份证号",
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseAgentIdNo),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseAgentIdNo", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseAgentIdNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经办人联系电话",
      "required": true,
      "prop": "enterpriseAgentContact"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "请输入经办人联系电话",
      "disabled": _vm.isEditable,
      "maxlength": 11
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseAgentContact),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseAgentContact", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseAgentContact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业注册类型",
      "prop": "registrationType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.registrationType),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "registrationType", $$v)
      },
      expression: "enterpriseInfoFormModel.registrationType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("多证合一")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("组织机构代码证号")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.registrationType) === 0 ? '组织机构代码证号' : '社会信用代码号',
      "required": true,
      "prop": "enterpriseOrganizingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.enterpriseInfoFormModel.registrationType) === 0 ? '请输入组织机构代码证号' : '请输入社会信用代码号',
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseOrganizingNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseOrganizingNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseOrganizingNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请上传营业执照"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('ul', {
    staticClass: "file-list__item-list"
  }, [_vm._l((_vm.sysFileIds), function(file) {
    return [_c('li', {
      staticClass: "file-list__item-preview",
      staticStyle: {
        "width": "50%",
        "margin-left": "1px"
      }
    }, [_c('img', {
      attrs: {
        "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + _vm.tokenId)
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.canDel),
        expression: "canDel"
      }],
      staticClass: "file-list__item-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteUploadedFile(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })])])]
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sysFileIds.length < 1),
      expression: "sysFileIds.length < 1"
    }],
    staticClass: "file-list__select-file",
    staticStyle: {
      "width": "50%",
      "margin-left": "1px"
    },
    attrs: {
      "id": "picker"
    }
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": "请上传法定代表人身份证正反面"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('ul', {
    staticClass: "file-list__item-list1"
  }, [_vm._l((_vm.idCardFrontId), function(file) {
    return [_c('li', {
      staticClass: "file-list__item-preview2"
    }, [_c('img', {
      attrs: {
        "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + _vm.tokenId)
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.canDel),
        expression: "canDel"
      }],
      staticClass: "file-list__item-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteUploadedFile2(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })])])]
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.idCardFrontId.length < 1),
      expression: "idCardFrontId.length < 1"
    }],
    staticClass: "file-list__select-file2",
    staticStyle: {
      "width": "270px",
      "height": "200px"
    },
    attrs: {
      "id": "reder3"
    }
  })], 2)]), _vm._v(" "), _c('el-form-item', [_vm._l((_vm.idCardBackId), function(file) {
    return [_c('li', {
      staticClass: "file-list__item-preview2",
      staticStyle: {
        "margin-top": "-222px",
        "margin-left": "155px"
      }
    }, [_c('img', {
      attrs: {
        "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + _vm.tokenId)
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.canDel),
        expression: "canDel"
      }],
      staticClass: "file-list__item-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteUploadedFile3(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })])])]
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.idCardBackId.length < 1),
      expression: "idCardBackId.length < 1"
    }],
    staticClass: "file-list__select-file2",
    staticStyle: {
      "width": "270px",
      "height": "200px",
      "margin-top": "-222px",
      "margin-left": "150px"
    },
    attrs: {
      "id": "reder4"
    }
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tips_info el-icon-information"
  }, [_vm._v("如有信息出错，请联系管理员修改")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.stateCode == 1) ? _c('el-button', {
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("企业认证\n            ")]) : _vm._e(), _vm._v(" "), (_vm.stateCode == 0) ? _c('el-button', {
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving
    },
    on: {
      "click": _vm.submitForm2
    }
  }, [_vm._v("法定代表人认证\n            ")]) : _vm._e(), _vm._v(" "), (_vm.stateCode == 2) ? _c('el-button', {
    staticClass: "personal-center-form__alreadyAuth",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving,
      "disabled": _vm.stateCode === 2
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("待审核\n            ")]) : _vm._e(), _vm._v(" "), (_vm.stateCode == 3) ? _c('el-button', {
    staticClass: "personal-center-form__alreadyAuth",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving,
      "disabled": _vm.stateCode === 3
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("已认证\n            ")]) : _vm._e()], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "success-modal",
    attrs: {
      "top": "23%",
      "visible": _vm.realNameSuccessModal.show,
      "before-close": _vm.beforeCloseRealNameSuccessModal,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeRealNameSuccessModal
    }
  }, [_c('div', {
    staticClass: "success-modal__text"
  }, [_vm._v(_vm._s(_vm.realNameSuccessModal.content))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-143505f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/RealNameAuth.vue
// module id = 1053
// module chunks = 1